/**
 * Play a short pleasant chime using Web Audio API (no asset file needed).
 * Two ascending notes with fast decay — feels like a notification "ding".
 */
let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
  }
  return audioCtx;
}

export function playChime() {
  const ctx = getCtx();
  if (!ctx) return;
  // Resume if suspended (autoplay policy)
  if (ctx.state === "suspended") ctx.resume();

  const now = ctx.currentTime;
  const notes = [
    { f: 880, t: 0 },
    { f: 1318.5, t: 0.11 },
  ];
  notes.forEach(({ f, t }) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = f;
    gain.gain.setValueAtTime(0.0001, now + t);
    gain.gain.exponentialRampToValueAtTime(0.25, now + t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.35);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now + t);
    osc.stop(now + t + 0.4);
  });
}

/** Silent primer — call on first user interaction so mobile browsers allow sound later. */
export function primeAudio() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
}
